import axiosClient from '@/core/api/axiosClient';
import { ADMINISTRACION_ENDPOINTS } from './endpoints';

/**
 * DTOs para TipoUsuario
 */
export interface TipoUsuarioListaDto {
    id: number;
    nombre: string;
    descripcion?: string;
    activo: boolean;
    creadoEn: Date;
    cantidadUsuarios: number;
}

export interface TipoUsuarioDetalleDto {
    id: number;
    nombre: string;
    descripcion?: string;
    activo: boolean;
    camposJson?: string;
    creadoEn: Date;
    actualizadoEn?: Date;
    cantidadUsuarios: number;
}

export interface CrearTipoUsuarioDto {
    nombre: string;
    descripcion?: string;
    activo: boolean;
    camposJson?: string;
}

export interface ActualizarTipoUsuarioDto {
    nombre: string;
    descripcion?: string;
    activo: boolean;
    camposJson?: string;
}

/**
 * DTO para listar tipos de usuario con paginación
 */
export interface ListarTiposUsuarioDto {
    tiposUsuario: TipoUsuarioListaDto[];
    totalRegistros: number;
    paginaActual: number;
    totalPaginas: number;
    tamanoPagina: number;
}

/**
 * Response del backend (ApiResponse con PascalCase)
 */
export interface ApiResponse<T> {
    data?: T;
    message?: string;
    success: boolean;
    errors?: string[];
}

/**
 * Cliente SK para operaciones de TiposUsuario
 * Sigue el mismo patrón que authClient
 */
export const tipoUsuarioClient = {
    /**
     * Listar todos los tipos de usuario
     */
    listar: async (): Promise<ApiResponse<ListarTiposUsuarioDto>> => {
        const response = await axiosClient.get<ApiResponse<ListarTiposUsuarioDto>>(
            ADMINISTRACION_ENDPOINTS.TIPOS_USUARIO.BASE
        );
        return response.data;
    },

    /**
     * Obtener un tipo de usuario por ID
     */
    obtener: async (id: number): Promise<ApiResponse<TipoUsuarioDetalleDto>> => {
        const response = await axiosClient.get<ApiResponse<TipoUsuarioDetalleDto>>(
            ADMINISTRACION_ENDPOINTS.TIPOS_USUARIO.DETAIL(id)
        );
        return response.data;
    },

    /**
     * Crear un nuevo tipo de usuario
     */
    crear: async (data: CrearTipoUsuarioDto): Promise<ApiResponse<TipoUsuarioDetalleDto>> => {
        const response = await axiosClient.post<ApiResponse<TipoUsuarioDetalleDto>>(
            ADMINISTRACION_ENDPOINTS.TIPOS_USUARIO.BASE,
            data
        );
        return response.data;
    },

    /**
     * Actualizar un tipo de usuario existente
     */
    actualizar: async (id: number, data: ActualizarTipoUsuarioDto): Promise<ApiResponse<TipoUsuarioDetalleDto>> => {
        const response = await axiosClient.put<ApiResponse<TipoUsuarioDetalleDto>>(
            ADMINISTRACION_ENDPOINTS.TIPOS_USUARIO.DETAIL(id),
            data
        );
        return response.data;
    },

    /**
     * Eliminar un tipo de usuario
     */
    eliminar: async (id: number): Promise<ApiResponse<void>> => {
        const response = await axiosClient.delete<ApiResponse<void>>(
            ADMINISTRACION_ENDPOINTS.TIPOS_USUARIO.DETAIL(id)
        );
        return response.data;
    }
};
